/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as ReactGA from 'react-ga';

import {
  submit as formSubmit,
  initialize as formInitialize,
  change as fieldChange,
} from 'redux-form';
import { withRouter } from 'react-router-dom';

import queryString from 'query-string';
import { UserProfileContext } from 'auth/contexts/UserProfileContext';
import {
  getScrollableSearchResults,
  pagedScrollableSearchResults,
  searchBarFields,
  updateCurrentPage,
  setSearchForceRefresh,
  clearSearchResults,
} from 'state/reducers/search/searchActions';
import { getAutocomplete } from 'state/reducers/autocomplete/autocompleteActions';
import {
  SEARCH_REDUCERS,
  SEARCH_FORM_REDUCERS,
} from 'state/reducers/search/searchReducers';
import { AUTOCOMPLETE_REDUCERS } from 'state/reducers/autocomplete/autocompleteReducers';
import { PATIENT_REDUCERS } from 'state/reducers/patient/patientReducers';
import {
  SEARCH_TYPES,
  VALID_SEARCH_TYPES,
  tagTokenPrefix,
} from 'state/services/searchApiUtils';
import ROUTE_PATHS from 'routes/routePaths';
import PatientSearchField from 'views/components/Search/PatientSearchField';
import OrderingProviderSearchField from '../../components/Search/OrderingProviderSearchField';
import PatientSearchFilters from '../../components/Search/PatientSearchFilters';
import PatientSearchForm, { SEARCH_TYPE_OPTIONS } from './PatientSearchForm';
import {
  getSearchParamsFromQuery,
  getSearchQueryString,
} from './searchUrlUtils';

import styles from './PatientSearchBar.css';

class PatientSearchBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchType: SEARCH_TYPE_OPTIONS[0].value,
      searchParams: {
        page: 1,
      },
      isSearchHomeRequest: true,
      onPageReadySearchUpdate: false,
      valuesFromQueryParams: null,
      formInitialized: 0,
      pageLoadSearchStarted: false,
      tagRemoved: null,
    };
  }

  componentDidMount() {
    const {
      location,
      patientSearchResults,
      autocompleteResults,
      searchForceRefresh,
    } = this.props;
    const queryParams = queryString.parse(location.search);
    const { params } = this.props.match;
    const hasNoParams = Object.entries(queryParams).length === 0;
    const onPageReadySearchUpdate =
      patientSearchResults.totalPagesFetched !== 0 && // patientSearchResults redux state has not been populated
      !(typeof params.searchType === 'undefined' && hasNoParams); // on patient search home

    if (
      !hasNoParams &&
      autocompleteResults.fetchCompleted &&
      patientSearchResults.searchPerformed &&
      !searchForceRefresh
    ) {
      // console.log(' ... handling cached store state ... ');
      // use case: when user clicks back in the browser or UI navigation. Redux store should have cached it.
      // Also, we should only do this if it's from previous search vs from home page.
      this.updateSearchParamsFromUrl(() => {
        const { valuesFromQueryParams } = this.state;
        // Delay submitting form b/c have to wait for team data to available via async request.
        this.initFormWithQueryParams(valuesFromQueryParams);
      });
    }

    this.setState({
      isSearchHomeRequest: hasNoParams,
      // only populate page with results when it's a search landing page experience.
      onPageReadySearchUpdate,
    });
  }

  componentDidUpdate(prevProps) {
    const { team } = this.context;
    const { onPageReadySearchUpdate } = this.state;
    const {
      dispatch,
      patientSearchResults,
      autocompleteResults,
      searchForceRefresh,
    } = this.props;

    if (
      typeof team !== 'undefined' &&
      team !== null &&
      !autocompleteResults.isFetching &&
      !autocompleteResults.fetchCompleted
    ) {
      dispatch(getAutocomplete());
    }

    if (
      !onPageReadySearchUpdate &&
      autocompleteResults.fetchCompleted &&
      team !== null
    ) {
      // this should be done on componentDidMount but can't because teams data is async and it is needed by search api.
      // solution is to save team id into localStorage from login and clear on
      // signout/kickout so it's not dependent on async calls.
      this.onPageReadySearch();
    } else if (
      onPageReadySearchUpdate &&
      // Can't use prevProps since the reducer data is being updated from the patient detail page.
      searchForceRefresh &&
      // search has been performed before. use case: navigating from search -> patient detail
      patientSearchResults.searchPerformed
    ) {
      this.handlePatientDataUpdate();
    }

    // workflow related prop update.
    if (
      this.props.patientSearchCurrentSort !== prevProps.patientSearchCurrentSort
    ) {
      this.handleSortUpdate();
    } else if (
      this.props.patientSearchCurrentPage !== prevProps.patientSearchCurrentPage
    ) {
      this.handlePageUpdate();
    }
  }

  onPageReadySearch() {
    // console.log('... handling onPageReadySearch ...');
    // const { profile, isPhysician } = this.context;
    const { dispatch, autocompleteResults } = this.props;
    // const { searchType, isSearchHomeRequest } = this.state;

    if (autocompleteResults.fetchCompleted) {
      // use case: patient search homepage
      // if (isPhysician() && isSearchHomeRequest) {
      //   // console.log('... handling physician search home ...');
      //   // pre-fill out the order provider value only if it's the search home.
      //   this.submitFormOnFormChange(() => {
      //     dispatch(
      //       formInitialize(
      //         SEARCH_FORM_REDUCERS.PATIENT_SEARCH,
      //         {
      //           searchType,
      //           filterByOrderingPhysicianID: profile.id,
      //         },
      //         true,
      //       ),
      //     );
      //   });
      // } else {
      // use cases:
      // 1) browser refresh of a search resulted url regardless of the auth user role.
      // We have to reset the page load started since params were already updated.
      // 2) user are not physician and search home.
      this.updateSearchParamsFromUrl(() => {
        const { valuesFromQueryParams } = this.state;
        // Delay submitting form b/c have to wait for team data to available via async request.
        this.initFormWithQueryParams(valuesFromQueryParams, true);
      });
      // }

      // make sure it's empty and not cached from previous navigations
      dispatch(clearSearchResults());
      this.setState({
        onPageReadySearchUpdate: true,
      });
    }
  }

  handleSearchTypeChange = searchType => {
    const { searchParams } = this.state;
    const { dispatch } = this.props;

    this.setState(
      {
        searchType,
      },
      () => {
        dispatch(searchBarFields(searchType, searchParams));
        this.performSearch();
        try {
          ReactGA.event({
            category: 'SearchBar',
            action: 'SearchType-Filter',
            label: searchType,
          });
        } catch (err) {
          // silently fail
        }
      },
    );
  };

  handleSubmit = values => {
    const { searchType, ...validFormValues } = values;
    const { dispatch, patientSearchResults } = this.props;
    const searchParams = {
      page: 1,
      ...validFormValues,
    };

    // check if search type was selected/being passed in from form.
    let selectedSearchType = searchType;
    if (!searchType) {
      selectedSearchType = this.state.searchType;
    }

    this.setState(
      {
        searchType: selectedSearchType,
        searchParams,
      },
      () => {
        // save off the search params used to perform search so components can manage their state.
        dispatch(searchBarFields(searchType, searchParams));
        this.performSearch();
        try {
          ReactGA.event({
            category: 'SearchBar',
            action: 'Button-Search',
            label: selectedSearchType,
            value: patientSearchResults.totalRecords,
          });
        } catch (err) {
          // silently fail
        }
      },
    );
  };

  handleClearRefinement = ({ name }) => {
    const { searchParams } = this.state;
    const { dispatch, patientSearchResults } = this.props;
    this.setState(
      {
        searchParams: {
          ...searchParams,
          [name]: null,
        },
      },
      () => {
        dispatch(formSubmit(SEARCH_FORM_REDUCERS.PATIENT_SEARCH));
        try {
          ReactGA.event({
            category: 'SearchBar',
            action: 'Search-Refinement-Clear',
            label: name,
            value: patientSearchResults.totalRecords,
          });
        } catch (err) {
          // silently fail
        }
      },
    );
  };

  handleRemoveTag = (field, value) => {
    this.setState({
      tagRemoved: { field: value },
    });
    // this.props.changeFieldValue(field, value);
    // this.props.dispatch(formSubmit(SEARCH_FORM_REDUCERS.PATIENT_SEARCH));
  };

  handleSelectedRefinement = (value, { name }) => {
    const { searchParams } = this.state;
    const { dispatch, patientSearchResults } = this.props;
    this.setState(
      {
        searchParams: {
          ...searchParams,
          [name]: value,
        },
      },
      () => {
        dispatch(formSubmit(SEARCH_FORM_REDUCERS.PATIENT_SEARCH));
        try {
          ReactGA.event({
            category: 'SearchBar',
            action: 'Search-Refinement-Filter',
            label: name,
            value: patientSearchResults.totalRecords,
          });
        } catch (err) {
          // silently fail
        }
      },
    );
  };

  // eslint-disable-next-line no-unused-vars
  onFormChange = (values, previousValues) => {
    const { formInitialized, pageLoadSearchStarted, tagRemoved } = this.state;
    // console.log(values);
    // console.log(previousValues);
    // console.log(
    //   `... form change event ... ${formInitialized} -- ${pageLoadSearchStarted}`,
    // );
    // performSearch after form is initialized. Should only do this once.
    if (formInitialized === 1 && !pageLoadSearchStarted) {
      // console.log(' ... submitting form ... ');
      this.props.dispatch(formSubmit(SEARCH_FORM_REDUCERS.PATIENT_SEARCH));
      this.setState({
        pageLoadSearchStarted: true,
      });
    } else if (tagRemoved) {
      this.props.dispatch(formSubmit(SEARCH_FORM_REDUCERS.PATIENT_SEARCH));
      this.setState({
        tagRemoved: null,
      });
    }
  };

  updateSearchParamsFromUrl(cb = null) {
    const { dispatch, location } = this.props;
    const queryParams = queryString.parse(location.search);
    const { params } = this.props.match;

    // set up form state base on the search query strings
    // use case: bookmark or history back event.
    const searchParams = getSearchParamsFromQuery(queryParams);
    const valuesFromQueryParams = {
      searchType: VALID_SEARCH_TYPES.includes(params.searchType)
        ? params.searchType
        : SEARCH_TYPE_OPTIONS[0].value,
      patients: '',
      providers: '',
      ...searchParams,
    };

    this.setState(
      prevState => {
        return {
          valuesFromQueryParams,
          searchType: valuesFromQueryParams.searchType,
          searchParams: {
            ...prevState.searchParams,
            ...valuesFromQueryParams, // state from redux-form
          },
        };
      },
      () => {
        // set so search results component has correct page number.
        dispatch(updateCurrentPage(this.state.searchParams.page));
        if (cb) cb();
      },
    );
  }

  initFormWithQueryParams(valuesFromQueryParams, broadcastFormChange = false) {
    if (broadcastFormChange) {
      this.submitFormOnFormChange();
    }

    this.props.dispatch(
      formInitialize(
        SEARCH_FORM_REDUCERS.PATIENT_SEARCH,
        valuesFromQueryParams,
        true,
      ),
    );
  }

  submitFormOnFormChange(cb = null) {
    // console.log('... handling submitFormOnFormChange ...');
    const { formInitialized } = this.state;
    // should only do this once via page load/navigation events.
    this.setState(
      {
        // make sure we only do this only once
        formInitialized: formInitialized + 1,
      },
      () => {
        if (cb) cb();
      },
    );
  }

  handlePageUpdate() {
    const { searchParams } = this.state;
    const { patientSearchCurrentPage } = this.props;
    if (patientSearchCurrentPage !== searchParams.page) {
      this.performPageSearch();
      try {
        ReactGA.event({
          category: 'SearchBar',
          action: 'Pagination-Update',
          label: patientSearchCurrentPage.toString(),
        });
      } catch (err) {
        // silently fail
      }
    }
  }

  handlePatientDataUpdate() {
    const { dispatch } = this.props;
    // make sure it's empty and not cached from previous navigations
    dispatch(clearSearchResults());
    dispatch(getAutocomplete());
    dispatch(setSearchForceRefresh(false));
    this.updateSearchParamsFromUrl(() => {
      const { valuesFromQueryParams } = this.state;
      // Delay submitting form b/c have to wait for team data to available via async request.
      this.initFormWithQueryParams(valuesFromQueryParams, true);
    });
    try {
      ReactGA.event({
        category: 'SearchBar',
        action: 'Search-Force-Refresh',
        label: 'Patient-Update',
      });
    } catch (err) {
      // silently fail
    }
  }

  handleSortUpdate() {
    const { searchParams } = this.state;
    const { patientSearchCurrentSort } = this.props;
    this.setState(
      {
        searchParams: {
          ...searchParams,
          ...patientSearchCurrentSort,
        },
      },
      () => {
        this.performSearch();
        try {
          ReactGA.event({
            category: 'SearchBar',
            action: 'Search-Sort',
            label: `${patientSearchCurrentSort.sortBy}-${patientSearchCurrentSort.sortDirection}`,
          });
        } catch (err) {
          // silently fail
        }
      },
    );
  }

  performPageSearch() {
    const { searchType, searchParams } = this.state;
    // page is updated by the search results table
    const { dispatch, patientSearchCurrentPage, handleScroll } = this.props;

    // Important when user goes to details page and back.
    dispatch(
      pagedScrollableSearchResults(
        searchType,
        searchParams,
        patientSearchCurrentPage,
      ),
    )
      .then(handleScroll)
      .catch(err => console.log(err));

    try {
      ReactGA.event({
        category: 'SearchBar',
        action: 'Pagination-Search',
        label: patientSearchCurrentPage.toString(),
      });
    } catch (err) {
      // silently fail
    }
  }

  performSearch() {
    const { searchType, searchParams } = this.state;
    // sort is updated by the search results table
    const { dispatch, patientSearchCurrentPage } = this.props;

    // use react-router to maintain app navigation state.
    this.updatePageQueryString();

    // check if page is out of sync with current page.
    if (patientSearchCurrentPage !== searchParams.page) {
      // console.log('performSearch ... updating current page');
      dispatch(updateCurrentPage(searchParams.page));
    }
    dispatch(getScrollableSearchResults(searchType, searchParams)).catch(err =>
      console.log(err),
    );
  }

  updatePageQueryString() {
    const { searchParams } = this.state;
    const { history } = this.props;
    // filter out params we don't need in the url query string.
    const {
      filterByMember,
      searchType,
      patients,
      providers,
      ...validParams
    } = searchParams;
    const selectedSearchType = this.state.searchType;

    const searchQueryParams = { ...validParams };
    if (selectedSearchType === SEARCH_TYPES.ORDERING_PHYSICIAN) {
      searchQueryParams.providers = providers;
    } else {
      searchQueryParams.patients = patients;
    }

    history.push({
      pathname: `${ROUTE_PATHS.PATIENTS_SEARCH_HOME}/${this.state.searchType}`,
      search: `?${getSearchQueryString(searchQueryParams)}`,
    });
  }

  render() {
    const { hasUserData } = this.context;
    const { searchType, searchParams } = this.state;
    const { patientSearchResults, autocompleteResults } = this.props;
    const {
      billingCodes,
      orderingProvider,
      participants,
    } = autocompleteResults;

    const billingCodeOptions = billingCodes || [];
    const orderingProviderOptions = orderingProvider || [];
    const autocompleteLoading = autocompleteResults.isFetching === true;
    return (
      <div className={styles.patientSearchBar}>
        <PatientSearchForm
          onFormChange={this.onFormChange}
          selectedSearchType={searchType}
          styles={styles}
          isSubmitting={
            patientSearchResults.isFetching === true || !hasUserData()
          }
          onSubmit={this.handleSubmit}
          onSearchTypeChange={this.handleSearchTypeChange}
          searchFieldComponent={(() => {
            switch (searchType) {
              case SEARCH_TYPES.ORDERING_PHYSICIAN:
                return (
                  <OrderingProviderSearchField
                    autocompleteData={orderingProvider}
                    isLoading={autocompleteLoading}
                    styles={styles}
                    defaultValue={searchParams.providers}
                    onRemoveTag={this.handleRemoveTag}
                  />
                );
              case SEARCH_TYPES.PATIENT:
              default:
                return (
                  <PatientSearchField
                    isLoading={autocompleteLoading}
                    autocompleteData={participants}
                    styles={styles}
                    defaultValue={searchParams.patients}
                    tokenPrefix={tagTokenPrefix}
                    onRemoveTag={this.handleRemoveTag}
                  />
                );
            }
          })()}
        >
          {/* Search Refinement component setup base selected searchType */}
          {(() => {
            switch (searchType) {
              case SEARCH_TYPES.ORDERING_PHYSICIAN:
                return (
                  <PatientSearchFilters
                    showProviderOptions={false}
                    billingCodeOptions={billingCodeOptions}
                    onClear={this.handleClearRefinement}
                    onSelected={this.handleSelectedRefinement}
                    isLoading={autocompleteLoading}
                    styles={styles}
                    searchParams={searchParams}
                  />
                );
              case SEARCH_TYPES.PATIENT:
              default:
                return (
                  <PatientSearchFilters
                    orderingProviderOptions={orderingProviderOptions}
                    billingCodeOptions={billingCodeOptions}
                    onClear={this.handleClearRefinement}
                    onSelected={this.handleSelectedRefinement}
                    isLoading={autocompleteLoading}
                    styles={styles}
                    searchParams={searchParams}
                  />
                );
            }
          })()}
        </PatientSearchForm>
      </div>
    );
  }
}
PatientSearchBar.contextType = UserProfileContext;

// setup up redux search store
const mapStateToProps = ({ search, autocomplete, form, patient }) => {
  return {
    patientSearchResults: search[SEARCH_REDUCERS.INFINITE_SCROLL_REDUCER],
    patientSearchForm: form[SEARCH_FORM_REDUCERS.PATIENT_SEARCH],
    patientSearchCurrentPage: search[SEARCH_REDUCERS.SEARCH_CURRENT_PAGE],
    patientSearchCurrentSort: search[SEARCH_REDUCERS.SEARCH_CURRENT_SORT],
    patientHasBeenUpdated: patient[PATIENT_REDUCERS.PATIENT_UPDATED_TRIGGER],
    searchForceRefresh: search[SEARCH_REDUCERS.SEARCH_FORCE_REFRESH],
    autocompleteResults:
      autocomplete[AUTOCOMPLETE_REDUCERS.AUTOCOMPLETE_RESULTS],
    autocompleteForceRefresh:
      autocomplete[AUTOCOMPLETE_REDUCERS.AUTOCOMPLETE_FORCE_REFRESH],
  };
};
function mapDispatchToProps(dispatch) {
  return {
    changeFieldValue(field, value) {
      return dispatch(
        fieldChange(SEARCH_FORM_REDUCERS.PATIENT_SEARCH, field, value),
      );
    },
    dispatch,
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PatientSearchBar),
);



// WEBPACK FOOTER //
// ./src/views/containers/Search/PatientSearchBar.jsx